import { createClient } from "@sanity/client";

const client = createClient({
    projectId: '6a5mwhag',
    dataset: 'production',
    useCdn: true,
    token: 'skXmgELVXEFA2jxtRMqgS82GKEIowbNgHzlObfOFzQfVNgGV3BUuO4KbX4HutOQ0mwOXTjBgLhJ3oVZsVnY2iDorMmSLpvrfDD7mItUPMbw9ocuCHHzTbBa7VwrnwZqPLxKCXlEoJELOKnYwIkvwQSUPhaJRTyxUNnZGEbLbcG3UEa9YtNTB',
})

export default client